import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import configureAxios from './config/axios';
import interceptor from './utils/axios-custom-interceptor';
import vuetify from './plugins/vuetify';
import './plugins/font-awesome'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/utils/global-components';
// import { isAuthenticated } from '@/auth';

Vue.config.productionTip = false;

configureAxios();

interceptor();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
